import { Country } from '@cash-web/protos/squareup/common/countries.pb'
import { InstrumentType } from '@cash-web/protos/squareup/common/instrument.pb'
import { GlobalAddress } from '@cash-web/protos/squareup/common/location.pb'
import logger from '@cash-web/shared/util-logger'

import { ApplePayPaymentNetwork } from './types'

export const formatAmount = (amount: number) => {
  return (amount / 100).toFixed(2)
}

export const INSTRUMENT_TYPE_TO_APPLE_PAY_NETWORK: Partial<Record<InstrumentType, ApplePayPaymentNetwork>> = {
  [InstrumentType.VISA]: 'visa',
  [InstrumentType.MASTER_CARD]: 'masterCard',
  [InstrumentType.AMERICAN_EXPRESS]: 'amex',
  [InstrumentType.DISCOVER]: 'discover',
  [InstrumentType.JCB]: 'jcb',
  [InstrumentType.INTERAC]: 'interac',
  [InstrumentType.EFTPOS]: 'eftpos',
}

export function getSupportedNetworks(cashInstrumentTypes: InstrumentType[]) {
  return cashInstrumentTypes
    .map(instrumentType => {
      const network = INSTRUMENT_TYPE_TO_APPLE_PAY_NETWORK[instrumentType]

      if (!network) {
        logger.warn(new Error(`Instrument type not found in Apple Pay Network map: ${instrumentType}`))
      }

      return network
    })
    .filter(Boolean) as ApplePayPaymentNetwork[]
}

export function toGlobalAddress(address?: ApplePayJS.ApplePayPaymentContact): GlobalAddress {
  if (!address) {
    return {}
  }

  return {
    address_line_1: address.addressLines?.[0],
    address_line_2: address.addressLines?.[1],
    address_line_3: address.addressLines?.[2],
    locality: address.locality,
    sublocality: address.subLocality,
    administrative_district_level_1: address.administrativeArea,
    postal_code: address.postalCode,
    country_code: address.countryCode as Country,
  }
}
